<div class="login-page">
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h1>Получение роли</h1>
        <p>Для продолжения работы введите пароль</p>
      </div>

      <div class="login-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Пароль</mat-label>
          <input matInput
            [type]="showPassword() ? 'text' : 'password'"
            id="password"
            [value]="password()"
            (input)="password.set($any($event.target).value)"
            (keydown.enter)="onSubmit()"
            [disabled]="isLoading()"
            autocomplete="current-password"
          />
          <button mat-icon-button matSuffix type="button"
            (click)="togglePasswordVisibility()"
            [disabled]="isLoading()">
            <mat-icon>{{ showPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
        </mat-form-field>

        @if (errorMessage()) {
          <div class="field-error">{{ errorMessage() }}</div>
        }

        <div class="buttons">
          <button
            type="button"
            class="btn-login"
            (click)="onSubmit()"
            [disabled]="isLoading()"
          >
            @if (isLoading()) {
              <mat-spinner diameter="20" color="accent"></mat-spinner>
              Получение роли...
            } @else {
              Получить роль
            }
          </button>

          <button
            type="button"
            class="btn-logout"
            (click)="onLogout()"
            [disabled]="isLoading()"
          >
            Выйти
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
